/**
 * Centralized custom event names — prevents typo drift across components.
 * Every `dispatchEvent(new Event(...))` and `addEventListener(...)` should
 * reference these constants instead of raw strings.
 */
export const EVENTS = {
  NODES_CHANGED: 'nodes-changed',
  PAGES_CHANGED: 'pages-changed',
  FAVORITES_CHANGED: 'favorites-changed',
  PROFILE_AVATAR_CHANGED: 'profile-avatar-changed',
  EXIT_COMPOSER: 'exit-composer',
  PANEL_ONE_MODE_CHANGE: 'panel-one-mode-change',
};
